webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  "data-v-94971932",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Homepage__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Post__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Post__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'homepage',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Homepage___default.a
  }, {
    path: '/post/:id',
    name: 'post',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Post___default.a,
    props: function props(route) {
      return {
        id: route.params.id
      };
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismic_javascript__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismic_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prismic_javascript__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    query: null,
    posts: null,
    homepage: null
  },
  mutations: {
    updateApiData: function updateApiData(state, query) {
      state.query = query;
      state.posts = query.results.filter(function (item) {
        return item.type === 'article';
      });
      state.homepage = query.results.filter(function (item) {
        return item.type === 'homepage';
      });
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  data: function data() {
    return {
      apiEndpoint: 'https://changing-lawyer.prismic.io/api/v2'
    };
  },

  methods: {
    getPosts: function getPosts() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_prismic_javascript___default.a.getApi(this.apiEndpoint, {}).then(function (api) {
        return api.query([], {
          orderings: '[my.article.order]',
          pageSize: 50
        });
      }).then(function (response) {
        self.$store.commit('updateApiData', response);
      }, function (err) {
        console.log('Something went wrong: ', err);
      });
    }
  },
  mounted: function mounted() {
    this.getPosts();
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavMenu__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_NavMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  metaInfo: {
    title: 'The Changing Lawyer',
    titleTemplate: '%s | Microsystems'
  },
  components: {
    NavMenu: __WEBPACK_IMPORTED_MODULE_0__components_NavMenu___default.a
  },
  data: function data() {
    return {
      navOpen: false
    };
  },

  computed: {
    posts: function posts() {
      if (this.$store.state.posts && this.$store.state.posts.length) {
        return this.$store.state.posts;
      }
    }
  },
  methods: {
    toggleNav: function toggleNav(state) {
      if (state === 'on') {
        this.navOpen = true;
      } else if (state === 'off') {
        this.navOpen = false;
      } else {
        this.navOpen = !this.navOpen;
      }

      if (this.navOpen) {
        document.body.classList.add('js-nav-no-scroll');
      } else {
        document.body.classList.remove('js-nav-no-scroll');
      }
    },
    escapeKeyListener: function escapeKeyListener(evt) {
      if (evt.keyCode === 27 && this.navOpen) {
        this.toggleNav();
      }
    }
  },
  watch: {
    '$route': function $route(value) {
      this.toggleNav('off');
    }
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.escapeKeyListener);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_Video__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_content_Video__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-header',
  components: {
    ContentVideo: __WEBPACK_IMPORTED_MODULE_1__components_content_Video___default.a
  },
  props: ['post'],
  computed: {
    title: function title() {
      return this.post ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(this.post.data.title) : null;
    },
    url: function url() {
      return location.href;
    },
    category: function category() {
      return this.post ? this.post.data.category : 'No Category';
    }
  },
  methods: {
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str) : '';
    },
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-nav',
  props: {
    'prevPost': Object,
    'nextPost': Object
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'article-progress',
  data: function data() {
    return {
      progressPercent: 33
    };
  },

  computed: {},
  methods: {
    getProgress: function getProgress(str) {
      return '';
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading-animation'
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavMenuCategory__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavMenuCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_NavMenuCategory__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav-menu',
  components: {
    NavMenuCategory: __WEBPACK_IMPORTED_MODULE_0__components_NavMenuCategory___default.a
  },
  props: {
    posts: Array,
    isOpen: Boolean
  },
  methods: {},
  computed: {
    menuText: function menuText() {
      return this.isOpen ? 'Close ✕' : 'Menu ♢';
    },
    activeClass: function activeClass() {
      return this.isOpen ? 'is-active' : '';
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav-menu-category',
  props: {
    posts: Array,
    category: String
  },
  methods: {
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    filterCategory: function filterCategory(category) {
      return this.posts.filter(function (post) {
        return post.data.category === category;
      });
    },
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    }
  },
  computed: {
    menuText: function menuText() {
      return this.isOpen ? 'Close ✕' : 'Menu ♢';
    },
    activeClass: function activeClass() {
      return this.isOpen ? 'is-active' : '';
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'posts-cover',
  props: ['content'],
  computed: {
    intro: function intro() {
      return this.content.data.intro ? this.content.data.intro : null;
    },
    title: function title() {
      return this.content.data.title ? this.getTextContent(this.content.data.title) : null;
    }
  },
  methods: {
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str) : '';
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'posts-list',
  components: {},
  props: ['posts'],
  methods: {
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str) : '';
    },
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },
    getWidth: function getWidth(img) {
      return img.dimensions ? img.dimensions.width : null;
    },
    getHeight: function getHeight(img) {
      return img.dimensions ? img.dimensions.height : null;
    }
  },
  mounted: function mounted() {
    this.$emit('ready');
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'related-posts',
  props: {
    'prevPost': Object,
    'nextPost': Object,
    'category': String
  },
  methods: {
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-blockquote',
  props: ['content'],
  computed: {
    alignClass: function alignClass() {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none';
    },
    quote: function quote() {
      return this.content.primary.quote ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(this.content.primary.quote) : null;
    },
    source: function source() {
      return this.content.primary.source ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(this.content.primary.source) : null;
    }
  },
  methods: {
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-embed',
  props: ['content'],
  computed: {
    oEmbedScript: function oEmbedScript() {
      return this.content.primary.oembed.html;
    },
    hypeScript: function hypeScript() {
      return this.content.primary.hype_script;
    },
    embedType: function embedType() {
      return this.content.primary.type;
    },
    title: function title() {
      return this.content.primary.title ? this.getTextContent(this.content.primary.title) : null;
    },
    credit: function credit() {
      return this.content.primary.credit ? this.getHtmlContent(this.content.primary.credit) : null;
    },
    embedContentStyles: function embedContentStyles() {
      if (this.content.primary.hype_embed_width) {
        return {
          maxWidth: this.content.primary.hype_embed_width + 'px'
        };
      }
    }
  },
  methods: {
    generateHtmlFromStr: function generateHtmlFromStr(str) {
      return document.createRange().createContextualFragment(str);
    },
    renderEmbed: function renderEmbed(embed) {
      var html = this.generateHtmlFromStr(embed);
      this.$refs.embedElement.appendChild(html);
    },
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str, this.linkResolver) : '';
    }
  },
  mounted: function mounted() {
    if (this.embedType === 'oEmbed') {
      this.renderEmbed(this.oEmbedScript);
    } else if (this.embedType === 'Hype') {
      this.renderEmbed(this.hypeScript);
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-image',
  props: ['content'],
  computed: {
    alignClass: function alignClass() {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none';
    },
    caption: function caption() {
      return this.content.primary.caption ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(this.content.primary.caption) : null;
    },
    title: function title() {
      return this.content.primary.title ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(this.content.primary.title) : null;
    },
    image: function image() {
      if (this.content.primary.image.url) {
        return {
          url: this.content.primary.image.url,
          alt: this.content.primary.image.alt,
          width: this.content.primary.image.dimensions.width,
          height: this.content.primary.image.dimensions.height
        };
      }
    },
    mobileImage: function mobileImage() {
      if (this.content.primary.image.mobile && this.content.primary.image.mobile.url) {
        return {
          url: this.content.primary.image.mobile.url,
          alt: this.content.primary.image.mobile.alt,
          width: this.content.primary.image.mobile.dimensions.width,
          height: this.content.primary.image.mobile.dimensions.height
        };
      }
    }
  },
  methods: {
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-share',
  props: ['title', 'position'],
  computed: {
    encodedUrl: function encodedUrl() {
      return encodeURIComponent(location.href);
    },
    encodedTitle: function encodedTitle() {
      return encodeURIComponent(this.title);
    },
    facebookShareURL: function facebookShareURL() {
      return 'http://www.facebook.com/share.php?u=' + this.encodedUrl + '&t=' + this.encodedTitle;
    },
    twitterShareUrl: function twitterShareUrl() {
      var twitterUser = 'microsystems';
      return 'https://twitter.com/share?url=' + this.encodedUrl + '&via=' + twitterUser + '&text=' + this.encodedTitle;
    },
    linkedInShareUrl: function linkedInShareUrl() {
      return 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.encodedUrl + '&title=' + this.encodedTitle;
    }
  },
  methods: {
    facebookShareClick: function facebookShareClick() {
      var shareUrl = 'http://www.facebook.com/sharer.php?u=' + this.encodedUrl + '&t=' + this.encodedTitle;
      window.open(shareUrl, 'sharer', 'toolbar=0,status=0,width=626,height=436');
      return false;
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-stats',
  props: ['content'],
  computed: {
    items: function items() {
      return this.content.items;
    },
    alignClass: function alignClass() {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none';
    },
    title: function title() {
      return this.content.title ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(this.content.title) : null;
    }
  },
  methods: {
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },
    linkResolver: function linkResolver(doc) {
      return '#/post/' + doc.slug;
    },
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str, this.linkResolver) : '';
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_dom__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-text',
  props: ['content'],
  computed: {
    bodyContent: function bodyContent() {
      if (this.content.primary.dropcap && this.content.primary.dropcap.length > 0) {
        return '<div class="drop-cap">' + this.content.primary.dropcap + '</div> ' + this.getHtmlContent(this.content.primary.text);
      } else {
        return this.getHtmlContent(this.content.primary.text);
      }
    }
  },
  methods: {
    linkResolver: function linkResolver(doc) {
      return '#/post/' + doc.slug;
    },
    getTextContent: function getTextContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asText(str) : '';
    },
    getHtmlContent: function getHtmlContent(str) {
      return str ? __WEBPACK_IMPORTED_MODULE_0_prismic_dom___default.a.RichText.asHtml(str, this.linkResolver) : '';
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-video',
  props: ['video'],
  data: function data() {
    return {
      videoIsPlaying: this.video.primary.autoplay === 'Yes'
    };
  },

  computed: {
    poster: function poster() {
      if (this.video.primary.placeholder) {
        return {
          url: this.video.primary.placeholder.url,
          alt: this.video.primary.placeholder.alt,
          width: this.video.primary.placeholder.width,
          height: this.video.primary.placeholder.height
        };
      }
    },
    videoSources: function videoSources() {
      return this.video.items ? this.video.items : null;
    },
    autoplay: function autoplay() {
      return this.video.primary.autoplay === 'Yes';
    }
  },
  methods: {
    playPauseVideo: function playPauseVideo() {
      var videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer.paused) {
        videoPlayer.play();
        this.videoIsPlaying = true;
      } else {
        videoPlayer.pause();
        this.videoIsPlaying = false;
      }
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoadingAnimation__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoadingAnimation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoadingAnimation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostsCover__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostsCover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PostsCover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PostsList__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PostsList__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'homepage',
  props: ['posts'],
  components: {
    LoadingAnimation: __WEBPACK_IMPORTED_MODULE_0__components_LoadingAnimation___default.a,
    PostsCover: __WEBPACK_IMPORTED_MODULE_1__components_PostsCover___default.a,
    PostsList: __WEBPACK_IMPORTED_MODULE_2__components_PostsList___default.a
  },
  computed: {
    homepage: function homepage() {
      if (this.$store.state.homepage && this.$store.state.homepage.length) {
        return this.$store.state.homepage[0];
      }
    }
  },
  methods: {
    scrollJack: function scrollJack(elCatch, elTargetSm, elTargetMd) {
      if (window.innerWidth < 500) return;
      var elTarget = window.innerWidth >= 1200 ? elTargetMd : elTargetSm;
      elCatch = document.querySelectorAll(elCatch);
      elTarget = document.querySelectorAll(elTarget);

      var mouseWheelEvent = 'wheel';
      var scroller = function scroller(evt) {
        if (evt.deltaY && elTarget[0]) {
          elTarget[0].scrollLeft += evt.deltaY;
        } else {
          elTarget[0].scrollLeft += evt.deltaY;
        }
      };
      elCatch[0].addEventListener(mouseWheelEvent, scroller);

      var arrowKeys = function arrowKeys(evt) {
        if (evt.keyCode === 40 || evt.keyCode === 39) {
          elTarget[0].scrollLeft += 200;
        } else if (evt.keyCode === 38 || evt.keyCode === 37) {
          elTarget[0].scrollLeft -= 200;
        }
      };
      document.addEventListener('keydown', arrowKeys);
    },
    scrollListener: function scrollListener() {
      this.scrollJack('.js-x-scroll-catch', '.js-x-scroll-target-md', '.js-x-scroll-target-lg');
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var self = this;
      window.addEventListener('resize', self.scrollListener);
      document.body.classList.add('js-no-scroll');
    });
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    window.removeEventListener('resize', self.scrollListener);
    document.body.classList.remove('js-no-scroll');
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_javascript__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismic_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismic_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismic_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ArticleHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ArticleNav__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ArticleNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ArticleNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArticleProgress__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArticleProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ArticleProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LoadingAnimation__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LoadingAnimation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LoadingAnimation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_Image__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_content_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_content_Blockquote__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_content_Blockquote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_content_Blockquote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content_Embed__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content_Embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_content_Embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_content_Share__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_content_Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_content_Share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_content_Stats__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_content_Stats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_content_Stats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_content_Text__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_content_Text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_content_Text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_RelatedPosts__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_RelatedPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_RelatedPosts__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  metaInfo: function metaInfo() {
    return {
      title: this.post ? __WEBPACK_IMPORTED_MODULE_1_prismic_dom___default.a.RichText.asText(this.post.data.title) : 'The Changing Lawyer',
      meta: [{ description: this.post ? __WEBPACK_IMPORTED_MODULE_1_prismic_dom___default.a.RichText.asText(this.post.data.subtitle) : '' }]
    };
  },
  data: function data() {
    return {
      post: null
    };
  },

  components: {
    ArticleHeader: __WEBPACK_IMPORTED_MODULE_2__components_ArticleHeader___default.a,
    ArticleNav: __WEBPACK_IMPORTED_MODULE_3__components_ArticleNav___default.a,
    ArticleProgress: __WEBPACK_IMPORTED_MODULE_4__components_ArticleProgress___default.a,
    ContentImage: __WEBPACK_IMPORTED_MODULE_6__components_content_Image___default.a,
    ContentBlockquote: __WEBPACK_IMPORTED_MODULE_7__components_content_Blockquote___default.a,
    ContentEmbed: __WEBPACK_IMPORTED_MODULE_8__components_content_Embed___default.a,
    ContentShare: __WEBPACK_IMPORTED_MODULE_9__components_content_Share___default.a,
    ContentStats: __WEBPACK_IMPORTED_MODULE_10__components_content_Stats___default.a,
    ContentText: __WEBPACK_IMPORTED_MODULE_11__components_content_Text___default.a,
    LoadingAnimation: __WEBPACK_IMPORTED_MODULE_5__components_LoadingAnimation___default.a,
    RelatedPosts: __WEBPACK_IMPORTED_MODULE_12__components_RelatedPosts___default.a
  },
  props: ['id', 'posts'],
  watch: {
    id: function id() {
      this.getPost();
    }
  },
  computed: {
    title: function title() {
      return this.post ? __WEBPACK_IMPORTED_MODULE_1_prismic_dom___default.a.RichText.asText(this.post.data.title) : null;
    },
    url: function url() {
      return location.href;
    },
    category: function category() {
      return this.post ? this.post.data.category : 'No Category';
    }
  },
  methods: {
    getPost: function getPost() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_prismic_javascript___default.a.getApi('https://changing-lawyer.prismic.io/api/v2', {}).then(function (api) {
        return api.getByUID('article', self.id);
      }).then(function (response) {
        self.post = response;
      }, function (err) {
        console.log('Something went wrong: ', err);
      });
    },
    getContentBlock: function getContentBlock(type) {
      var typeMap = {
        text: 'ContentText',
        infographic: 'ContentEmbed',
        embed: 'ContentEmbed',
        quote: 'ContentBlockquote',
        image: 'ContentImage',
        stats: 'ContentStats'
      };
      if (typeMap.hasOwnProperty(type)) {
        return typeMap[type];
      } else {
        console.log('Content type not found:', type);
      }
    },
    toCssName: function toCssName(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },
    getPrevPost: function getPrevPost(currentPost) {
      if (this.posts) {
        var prevPostIndex = this.posts.length - 1;
        if (this.currentPostIndex(currentPost) - 1 > 0) {
          prevPostIndex = this.currentPostIndex(currentPost) - 1;
        }
        return this.posts[prevPostIndex];
      }
    },
    getNextPost: function getNextPost(currentPost) {
      if (this.posts) {
        var nextPostIndex = 0;
        if (this.posts.length > this.currentPostIndex(currentPost) + 1) {
          nextPostIndex = this.currentPostIndex(currentPost) + 1;
        }
        return this.posts[nextPostIndex];
      }
    },
    currentPostIndex: function currentPostIndex(currentPost) {
      if (this.posts) {
        return this.posts.findIndex(function (post) {
          return post.uid === currentPost.uid;
        });
      }
    },
    arrowKeyListener: function arrowKeyListener(evt) {
      if (evt.keyCode === 37 && this.post) {
        var nextPost = this.getNextPost(this.post);
        this.$router.push({ name: 'post', params: { id: nextPost.uid } });
      }

      if (evt.keyCode === 39 && this.post) {
        var prevPost = this.getPrevPost(this.post);
        this.$router.push({ name: 'post', params: { id: prevPost.uid } });
      }
    }
  },
  mounted: function mounted() {
    this.getPost(this.id);
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(45)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  "data-v-842e7318",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  "data-v-7f9f7ccc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  "data-v-4e01c358",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-5f206bb3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  "data-v-fecafa5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(76),
  /* scopeId */
  "data-v-2d3894a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(74),
  /* scopeId */
  "data-v-248117e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(75),
  /* scopeId */
  "data-v-28c993a7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  "data-v-37b0d2e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(73),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(79),
  /* scopeId */
  "data-v-3edb5e96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(72),
  /* scopeId */
  "data-v-14e7231a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  "data-v-10b7904c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(38)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  "data-v-7ab38c94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  "data-v-dc0c458e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  "data-v-b2d0632a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("stats stats--" + _vm.alignClass)
  }, _vm._l((_vm.items), function(item) {
    return _c('figure', {
      class: ("stat-item stat-item--" + (_vm.toCssName(item.stat_type)))
    }, [_c('header', {
      staticClass: "stat-item__header"
    }, [_c('span', {
      staticClass: "stat-item__number"
    }, [_vm._v(_vm._s(item.number_1))]), _vm._v(" "), (item.stat_type === 'Fraction') ? [_c('span', {
      staticClass: "stat-item__symbol"
    }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
      staticClass: "stat-item__number"
    }, [_vm._v(_vm._s(item.number_2))])] : _vm._e(), _vm._v(" "), (item.stat_type === 'Percentage') ? [_c('span', {
      staticClass: "stat-item__symbol"
    }, [_vm._v("%")])] : _vm._e()], 2), _vm._v(" "), _c('figcaption', {
      staticClass: "stat-item__contents"
    }, [(item.statistic_text) ? _c('div', {
      staticClass: "stat-item__text",
      domProps: {
        "innerHTML": _vm._s(_vm.getHtmlContent(item.statistic_text))
      }
    }) : _vm._e(), _vm._v(" "), (item.source) ? _c('div', {
      staticClass: "stat-item__source",
      domProps: {
        "innerHTML": _vm._s(item.source)
      }
    }) : _vm._e()])])
  }))
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("share-buttons share-buttons--" + _vm.position)
  }, [_c('a', {
    staticClass: "share-button",
    attrs: {
      "href": _vm.linkedInShareUrl,
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 64 64"
    }
  }, [_c('path', {
    attrs: {
      "d": "M53.25 0h-42.5C4.838 0 0 4.838 0 10.75v42.5C0 59.163 4.838 64 10.75 64h42.5C59.163 64 64 59.163 64 53.25v-42.5C64 4.838 59.163 0 53.25 0zM24 52h-8V24h8v28zm-4-32c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm32 32h-8V36c0-2.21-1.79-4-4-4s-4 1.79-4 4v16h-8V24h8v4.967C37.65 26.7 40.172 24 43 24c4.97 0 9 4.477 9 10v18z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "share-button",
    attrs: {
      "href": _vm.twitterShareUrl,
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "40",
      "viewBox": "0 0 56.7 56.7",
      "width": "40"
    }
  }, [_c('path', {
    attrs: {
      "d": "M52.8 15.1c-1.8 0.8-3.8 1.3-5.8 1.6 2.1-1.2 3.7-3.2 4.4-5.6 -2 1.2-4.1 2-6.4 2.5 -1.8-2-4.5-3.2-7.4-3.2 -5.6 0-10.1 4.5-10.1 10.1 0 0.8 0.1 1.6 0.3 2.3 -8.4-0.4-15.8-4.4-20.8-10.6 -0.9 1.5-1.4 3.2-1.4 5.1 0 3.5 1.8 6.6 4.5 8.4 -1.7-0.1-3.2-0.5-4.6-1.3 0 0 0 0.1 0 0.1 0 4.9 3.5 9 8.1 9.9 -0.8 0.2-1.7 0.4-2.7 0.4 -0.7 0-1.3-0.1-1.9-0.2 1.3 4 5 6.9 9.4 7 -3.5 2.7-7.8 4.3-12.6 4.3 -0.8 0-1.6 0-2.4-0.1 4.5 2.9 9.8 4.5 15.5 4.5 18.6 0 28.8-15.4 28.8-28.8 0-0.4 0-0.9 0-1.3C49.8 18.9 51.5 17.1 52.8 15.1z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "share-button share-button--facebook",
    attrs: {
      "href": _vm.facebookShareURL,
      "rel": "nofollow",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.facebookShareClick()
      }
    }
  }, [_c('span', {
    staticClass: "share-button__label"
  }, [_vm._v("Share on Facebook")]), _vm._v(" "), _c('svg', {
    attrs: {
      "enable-background": "new 0 0 40 40",
      "height": "40px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 56.693 56.693",
      "width": "56.693px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M40.43,21.739h-7.645v-5.014c0-1.883,1.248-2.322,2.127-2.322c0.877,0,5.395,0,5.395,0V6.125l-7.43-0.029  c-8.248,0-10.125,6.174-10.125,10.125v5.518h-4.77v8.53h4.77c0,10.947,0,24.137,0,24.137h10.033c0,0,0-13.32,0-24.137h6.77  L40.43,21.739z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "c-embed"
  }, [(_vm.title) ? _c('header', {
    staticClass: "c-embed_header"
  }, [_c('h3', {
    staticClass: "c-embed_title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "embedElement",
    staticClass: "c-embed__content",
    style: (_vm.embedContentStyles)
  }), _vm._v(" "), (_vm.credit) ? _c('figcaption', {
    staticClass: "c-embed_credit",
    domProps: {
      "innerHTML": _vm._s(_vm.credit)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-posts-list js-x-scroll-target-lg"
  }, [_vm._l((_vm.posts), function(post) {
    return [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      key: post.uid,
      class: ("c-post-card c-post-card--" + (_vm.toCssName(post.data.category))),
      attrs: {
        "id": post.uid
      }
    }, [_c('router-link', {
      staticClass: "c-post-card__link",
      attrs: {
        "to": {
          name: 'post',
          params: {
            id: post.uid
          }
        }
      }
    }, [(post.data.featured_image.url) ? _c('div', {
      staticClass: "c-post-card__media"
    }, [_c('img', {
      staticClass: "c-post-card__image",
      attrs: {
        "src": post.data.featured_image.url,
        "alt": post.data.featured_image.alt,
        "width": _vm.getWidth(post.data.featured_image),
        "height": _vm.getHeight(post.data.featured_image)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "c-post-card__content"
    }, [_c('h4', {
      staticClass: "c-posts-card__meta-category",
      domProps: {
        "innerHTML": _vm._s(post.data.category)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-post-card__title-wrapper"
    }, [_c('h3', {
      staticClass: "c-post-card__title",
      domProps: {
        "innerHTML": _vm._s(_vm.getTextContent(post.data.title))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-post-card__lead",
      domProps: {
        "textContent": _vm._s(_vm.getTextContent(post.data.subtitle))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "c-post-card__btn"
    }, [_vm._v("Read More")])])])])], 1)])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "c-related-posts"
  }, [(_vm.prevPost) ? _c('router-link', {
    class: ("c-related-post__btn c-related-post__btn--previous c-related-post__btn--" + (_vm.toCssName(_vm.prevPost.data.category))),
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.prevPost.uid
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-related-post__btn-text"
  }, [_vm._v("Read Previous")]), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__content"
  }, [_c('h5', {
    staticClass: "c-related-post__meta-category",
    domProps: {
      "innerHTML": _vm._s(_vm.prevPost.data.category)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__title-wrapper"
  }, [_c('h4', {
    staticClass: "c-related-post__title"
  }, [_vm._v(_vm._s(_vm.getTextContent(_vm.prevPost.data.title)))])])])]) : _vm._e(), _vm._v(" "), (_vm.nextPost) ? _c('router-link', {
    class: ("c-related-post__btn c-related-post__btn--next c-related-post__btn--" + (_vm.toCssName(_vm.nextPost.data.category))),
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.nextPost.uid
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-related-post__btn-text"
  }, [_vm._v("Read Next")]), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__content"
  }, [_c('h5', {
    staticClass: "c-related-post__meta-category",
    domProps: {
      "innerHTML": _vm._s(_vm.nextPost.data.category)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__title-wrapper"
  }, [_c('h4', {
    staticClass: "c-related-post__title"
  }, [_vm._v(_vm._s(_vm.getTextContent(_vm.nextPost.data.title)))])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "c-cover"
  }, [_c('div', {
    staticClass: "c-cover__media"
  }, [_c('div', {
    staticClass: "c-cover__title-wrapper"
  }, [_c('span', {
    staticClass: "c-cover__intro"
  }, [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('h1', {
    staticClass: "c-cover__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('img', {
    staticClass: "c-cover__image",
    attrs: {
      "src": _vm.content.data.cover.url,
      "alt": _vm.content.data.cover.alt,
      "width": _vm.content.data.cover.dimensions.width,
      "height": _vm.content.data.cover.dimensions.height
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "c-cover__download",
    attrs: {
      "href": _vm.content.data.pdf_download.url,
      "target": "_blank"
    }
  }, [_vm._v("Download a complete version of The Changing Lawyer here")]), _vm._v(" "), _c('a', {
    staticClass: "c-cover__link-back",
    attrs: {
      "href": "//litera.com/",
      "target": "_self"
    }
  }, [_vm._v("Visit Litera Microsystems")])])])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('blockquote', {
    class: ("blockquote blockquote--" + _vm.alignClass)
  }, [_c('div', {
    staticClass: "blockquote__quote",
    domProps: {
      "innerHTML": _vm._s(_vm.quote)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blockquote__source",
    domProps: {
      "innerHTML": _vm._s(_vm.source)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-block",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyContent)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    class: ("c-image c-image--" + _vm.alignClass)
  }, [(_vm.title) ? _c('header', {
    staticClass: "c-image__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.image.url) ? _c('img', {
    staticClass: "c-image__media",
    attrs: {
      "src": _vm.image.url,
      "alt": _vm.image.alt,
      "width": _vm.image.width,
      "height": _vm.image.height
    }
  }) : _vm._e(), _vm._v(" "), (_vm.caption) ? _c('figcaption', {
    staticClass: "c-image__caption",
    domProps: {
      "innerHTML": _vm._s(_vm.caption)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.posts) ? _c('nav-menu', {
    attrs: {
      "posts": _vm.posts,
      "isOpen": _vm.navOpen
    },
    on: {
      "toggleNav": _vm.toggleNav
    }
  }, [_vm._v("Menu")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "posts": _vm.posts
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    ref: "progress-bar",
    staticClass: "progress-bar",
    style: ({
      Width: _vm.progressPercent + '%'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "c-nav-menu"
  }, [_c('button', {
    class: ("c-nav-menu__button " + _vm.activeClass),
    on: {
      "click": function($event) {
        _vm.$emit('toggleNav')
      }
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('span', {
    staticClass: "c-nav-menu__button-text"
  }, [_vm._v("Menu")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "c-nav-menu__items-wrapper"
  }, [_c('div', {
    staticClass: "c-nav-menu__items"
  }, [_c('div', {
    staticClass: "c-nav-menu__items-scroll"
  }, [_c('a', {
    staticClass: "c-nav-menu__logo logo",
    attrs: {
      "href": "//litera.com/",
      "rel": "nofollow",
      "alt": "Browse back to litera.com",
      "target": "_self"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 288 21.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.7 4.8c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v13h5.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4H37c-.3 0-.4-.2-.4-.4l.1-15.3zm11.7 0c0-.2.2-.4.4-.4H51c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4V4.8zm9.5 2.3h-3.6c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10.2c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-3.6v13c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4v-13zm9.4-2.3c0-.2.2-.4.4-.4h9.5c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-6.9V11H76c.2 0 .4.2.4.4v1.9c0 .3-.2.4-.4.4h-5.7v4.1h6.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-9.5c-.3 0-.4-.2-.4-.4V4.8zm13.7 0c0-.2.2-.4.4-.4H88c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7l3.2 5.9c.2.3 0 .7-.4.7h-2.4c-.2 0-.3-.1-.4-.2l-3.1-6.2H84v5.9c0 .2-.2.4-.4.4h-2.1c-.3 0-.4-.2-.4-.4L81 4.8zm6.8 7c1.2 0 2.3-1.1 2.3-2.4 0-1.2-1.1-2.3-2.3-2.3H84v4.6h3.8v.1zm6.6 8.2l7.2-15.6c.1-.1.2-.3.4-.3h.2c.2 0 .3.1.4.3l7.2 15.6c.1.3 0 .6-.4.6h-2c-.3 0-.5-.1-.7-.5l-1.1-2.5h-7l-1.1 2.5c-.1.2-.3.5-.7.5h-2c-.4 0-.6-.3-.4-.6zm10-4.9l-2.3-5.1h-.1l-2.3 5.1h4.7zm14.5-10.6c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H132c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm18.5.3c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V4.8zm14.1-.7c2.3 0 4 .8 5.6 2.2.2.2.2.5 0 .7l-1 1c-.2.2-.4.2-.6 0-1.1-1-2.6-1.6-4-1.6-3.3 0-5.8 2.8-5.8 6s2.5 6 5.9 6c1.7 0 2.9-.7 4-1.5.2-.2.4-.1.6 0l1.1 1c.2.2.1.5 0 .6-1.6 1.5-3.6 2.3-5.7 2.3-4.6 0-8.4-3.7-8.4-8.3s3.6-8.4 8.3-8.4zm9 .7c0-.2.2-.4.4-.4h6.3c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7L172 20c.2.3 0 .7-.4.7h-1.8c-.2 0-.3-.1-.4-.2l-3.1-6.2h-3.5v5.9c0 .2-.2.4-.4.4h-1.5c-.3 0-.4-.2-.4-.4V4.8zm6.6 7.5c1.5 0 2.8-1.3 2.8-2.9 0-1.5-1.3-2.8-2.8-2.8H163v5.6h4.1v.1zm16-8.2c4.7 0 8.4 3.7 8.4 8.4s-3.7 8.3-8.4 8.3c-4.6 0-8.3-3.7-8.3-8.3s3.6-8.4 8.3-8.4zm0 14.4c3.3 0 6-2.7 6-6s-2.7-6.1-6-6.1-6 2.8-6 6.1 2.7 6 6 6zm10.6-.2c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7zm16.8-5.5L205 5c-.2-.3 0-.7.4-.7h1.7c.2 0 .3.1.4.2l4.2 5.9 4.2-5.9c.1-.1.2-.2.4-.2h1.7c.4 0 .6.4.4.7l-5.5 7.7v7.4c0 .2-.2.4-.4.4H211c-.3 0-.4-.2-.4-.4l-.1-7.3zm9.1 5.5c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.3-.2-.5-.3-.2-.7zm15.7-11.8h-3.8c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-3.8v13.6c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V6.5h-.1zm9.2-1.7c0-.2.2-.4.4-.4h9.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-7.3v4.7h6.2c.2 0 .4.2.4.4V13c0 .3-.2.4-.4.4h-6.2v5h7.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-9.3c-.3 0-.4-.2-.4-.4V4.8zm15.4-.3c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H273c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm17.4 13.8c.2-.3.4-.7.6-1s.5-.4.8-.2c.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#f26924",
      "d": "M17.4.3c-1.3 0-1.9 1.1-1.3 2.3l8.4 18h6c1.3 0 1.9-1.1 1.3-2.3L23.4.3h-6z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#fdb714",
      "d": "M8.2 6.7l6.5 13.9h6c1.3 0 1.9-1.1 1.3-2.3l-6.6-14h-6c-1.3 0-1.8 1.1-1.2 2.4z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#00a176",
      "d": "M.6 11.9l4.1 8.7h6c1.3 0 1.9-1.1 1.3-2.3L7.9 9.6h-6c-1.3 0-1.9 1-1.3 2.3z"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "c-nav-menu__item-contents"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Leadership",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Legal Market",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Legal Tech",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Management",
      "posts": _vm.posts
    }
  })], 1), _vm._v(" "), (['post'].indexOf(_vm.$route.name) > -1) ? _c('router-link', {
    staticClass: "c-home-button",
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('svg', {
    staticClass: "c-home-button__icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z",
      "fill": "#121313"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-home-button__text"
  }, [_vm._v("Back to Cover")])]) : _vm._e()], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "nav-underlay",
    on: {
      "click": function($event) {
        _vm.$emit('toggleNav')
      }
    }
  }) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav-menu__button-box"
  }, [_c('div', {
    staticClass: "c-nav-menu__button-inner"
  })])
}]}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('div', {
    staticClass: "video-wrapper"
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "video-player",
    attrs: {
      "poster": _vm.poster.url,
      "autoplay": _vm.autoplay,
      "controls": "",
      "width": "1920",
      "height": "1080"
    },
    on: {
      "click": function($event) {
        _vm.playPauseVideo()
      }
    }
  }, [_vm._l((_vm.videoSources), function(video) {
    return [_c('source', {
      attrs: {
        "src": video.url,
        "type": ("video/" + (video.format))
      }
    })]
  }), _vm._v("\n      Your browser does not support HTML5 video.\n    ")], 2)]), _vm._v(" "), (!_vm.videoIsPlaying) ? _c('svg', {
    staticClass: "video-play-button",
    attrs: {
      "viewBox": "0 0 200 200",
      "alt": "Play video"
    },
    on: {
      "click": function($event) {
        _vm.playPauseVideo()
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "90",
      "fill": "none",
      "stroke-width": "15",
      "stroke": "#fff"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "70, 55 70, 145 145, 100",
      "fill": "#fff"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.videoIsPlaying) ? _c('a', {
    staticClass: "v-more",
    attrs: {
      "href": "#video-article"
    }
  }, [_c('span'), _vm._v("read more")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "article-nav"
  }, [(_vm.prevPost) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.prevPost.uid
        }
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z",
      "fill": "#121313"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "c-home-button",
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('svg', {
    staticClass: "home",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    attrs: {
      "d": "M50,4.9L5.1,47L5,47.1v9.7l11.1-10.6v48.6h67.8V46.3L95,56.9v-9.7L50,4.9z M50,14.3l27.6,26v48.3h-55V40L50,14.3z"
    }
  })])]), _vm._v(" "), (_vm.nextPost) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.nextPost.uid
        }
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "32",
      "viewBox": "0 0 32 32",
      "width": "32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32 16c0-0.3-0.1-0.5-0.3-0.7l-9.9-10c-0.4-0.4-1-0.4-1.4 0 -0.4 0.4-0.4 1 0 1.4l8.2 8.3H1c-0.6 0-1 0.5-1 1s0.4 1 1 1h27.6l-8.2 8.3c-0.4 0.4-0.4 1 0 1.4 0.4 0.4 1 0.4 1.4 0l9.9-10C31.9 16.5 32 16.3 32 16z",
      "fill": "#121313"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(_vm.post.data.body1[0]) ? _c('div', {
    staticClass: "video-header"
  }, [_c('content-video', {
    attrs: {
      "video": _vm.post.data.body1[0]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "post-meta__category",
    domProps: {
      "innerHTML": _vm._s(_vm.category)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "block",
      "appear": ""
    }
  }, [_c('h1', {
    key: ((_vm.post.uid) + "-title"),
    staticClass: "post-title reveal-text",
    attrs: {
      "id": "video-article"
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 1) : _c('div', {
    staticClass: "image-header"
  }, [_c('img', {
    staticClass: "post-image",
    attrs: {
      "src": _vm.post.data.featured_image.url,
      "alt": _vm.post.data.featured_image.alt,
      "width": _vm.post.data.featured_image.width,
      "height": _vm.post.data.featured_image.height
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "post-meta__category",
    domProps: {
      "innerHTML": _vm._s(_vm.category)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "block",
      "appear": ""
    }
  }, [_c('h1', {
    key: ((_vm.post.uid) + "-title"),
    staticClass: "post-title reveal-text"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-preloader"
  }, [_c('div', {
    staticClass: "c-preloader__spinner"
  }, [_c('div', {
    staticClass: "c-preloader__spinner-dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-preloader__spinner-dot2"
  })])])
}]}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.post) ? _c('article', {
    key: ((_vm.post.uid) + "-article"),
    staticClass: "post"
  }, [_c('article-nav', {
    class: _vm.toCssName(_vm.category),
    attrs: {
      "prevPost": _vm.getPrevPost(_vm.post),
      "nextPost": _vm.getNextPost(_vm.post)
    }
  }), _vm._v(" "), _c('article-header', {
    class: _vm.toCssName(_vm.category),
    attrs: {
      "post": _vm.post
    }
  }), _vm._v(" "), _c('main', {
    class: _vm.toCssName(_vm.category)
  }, [_c('content-share', {
    attrs: {
      "title": _vm.title,
      "position": "top"
    }
  }), _vm._v(" "), _vm._l((this.post.data.body), function(contentBlock) {
    return _c('div', {
      class: ("post-content post-content--" + (contentBlock.slice_type))
    }, [_c(_vm.getContentBlock(contentBlock.slice_type), {
      tag: "component",
      attrs: {
        "content": contentBlock
      }
    })], 1)
  }), _vm._v(" "), _c('content-share', {
    attrs: {
      "title": _vm.title,
      "position": "bottom"
    }
  })], 2), _vm._v(" "), _c('related-posts', {
    attrs: {
      "prevPost": _vm.getPrevPost(_vm.post),
      "nextPost": _vm.getNextPost(_vm.post)
    }
  })], 1) : _c('article', {
    key: "false"
  }, [_c('loading-animation')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "homepage js-x-scroll-catch"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.posts) ? _c('div', {
    key: "true",
    staticClass: "c-posts-wrapper js-x-scroll-target-md"
  }, [_c('posts-cover', {
    attrs: {
      "content": _vm.homepage
    }
  }), _vm._v(" "), _c('posts-list', {
    attrs: {
      "posts": _vm.posts
    },
    on: {
      "ready": function($event) {
        _vm.scrollListener()
      }
    }
  })], 1) : _c('div', {
    key: "false"
  }, [_c('loading-animation')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("c-nav-menu__category c-nav-menu__category--" + (_vm.toCssName(_vm.category)))
  }, [_c('h4', {
    staticClass: "c-nav-menu__item"
  }, [_vm._v(_vm._s(_vm.category))]), _vm._v(" "), _c('ul', {
    staticClass: "c-nav-menu__category-list"
  }, [_vm._l((_vm.filterCategory(_vm.category)), function(post) {
    return (_vm.posts) ? [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('li', {
      class: ("c-nav-menu__category-list-item " + (_vm.toCssName(_vm.category)))
    }, [_c('router-link', {
      staticClass: "c-nav-menu__category-list-link",
      attrs: {
        "to": {
          name: 'post',
          params: {
            id: post.uid
          }
        }
      }
    }, [_c('span', {}, [_vm._v(_vm._s(_vm.getTextContent(post.data.title)))])])], 1)])] : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.8cfa67d671a1961ce34e.js